import styled from 'styled-components';
import { media } from '../../utils/media';
import { MODAL, WHITE } from '../../utils/colors';
import { ReactComponent as CloseIconComponent } from '../../images/close-icon.svg';
import { ZINDEX } from '../../utils/constants';

export const customStyles = (isDesktop) => ({
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    maxWidth: '780px',
    height: '80%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: ZINDEX.MODAL,
    padding: isDesktop ? '20px' : '10px',
    overflow: 'visible',
  },
  overlay: {
    backgroundColor: MODAL.BACKGROUND_COLOR,
    zIndex: ZINDEX.MODAL,
  },
});

export const CloseButton = styled.button`
  position: absolute;
  cursor: pointer;
  border: none;
  padding: 12px 20px;
  background-color: ${MODAL.BUTTON_CLOSE_COLOR};
  display: flex;
  justify-content: center;
  align-items: center;
  right: 0;
  top: -80px;
  z-index: ${ZINDEX.MODAL_CLOSE_BUTTON};

  ${media.tablet`
    right: 36px;
    top: 36px;
  `};
`;

export const ModalContent = styled.div`
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  z-index: ${ZINDEX.MODAL_CONTENT};
`;

export const CloseText = styled.p`
  color: ${WHITE};
  font-size: 24px;
  letter-spacing: 1.8px;
  text-align: center;
  margin: unset;
`;

export const CloseIcon = styled(CloseIconComponent)`
  margin-left: 14px;

  path {
    stroke: ${WHITE};
    stroke-width: 0.5;
  }
`;

export const ButtonWrapper = styled.div`
  height: 100%;
  width: 100%;
  position: fixed;

  ${media.tablet`
      height: 100vh;
      width: 100vw;
  `}
`;
